import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ImageCacheService } from 'src/app/services/data/image-cache.service';
import { StorageService } from 'src/app/services/data/storage.service';
import { LoginService } from 'src/app/services/auth/login.service';

@Component({
  selector: 'app-image-lightbox',
  templateUrl: './image-lightbox.component.html',
  styleUrls: ['./image-lightbox.component.scss'],
  standalone: false,
})
export class ImageLightboxComponent implements OnInit {
  @Input() images: string[] = [];
  @Input() startIndex = 0;

  currentIndex = 0;
  downloading = false;
  showDownload = false;

  constructor(
    private modalCtrl: ModalController,
    private imageCache: ImageCacheService,
    private storage: StorageService,
    private login: LoginService,
  ) {}

  async ngOnInit() {
    this.currentIndex = this.startIndex;
    const setting = (await this.storage.getData<string>('imageDownload')) ?? 'admin';
    const role = this.login.decodedToken?.role ?? '';
    if (setting === 'all') this.showDownload = true;
    else if (setting === 'admin') this.showDownload = role === 'admin';
    else this.showDownload = false;
  }

  get current(): string {
    return this.images[this.currentIndex] ?? '';
  }

  prev() {
    if (this.currentIndex > 0) this.currentIndex--;
  }

  next() {
    if (this.currentIndex < this.images.length - 1) this.currentIndex++;
  }

  async download() {
    const url = this.current;
    if (!url || this.downloading) return;
    this.downloading = true;
    try {
      const dataUrl = await this.imageCache.resolve(url);
      if (!dataUrl) return;
      const a = document.createElement('a');
      a.href = dataUrl;
      a.download = url.split('/').pop()?.split('?')[0] || 'bild.jpg';
      a.click();
    } finally {
      this.downloading = false;
    }
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
